import React, { useState, useEffect } from 'react';
import { Container, Grid } from '@material-ui/core';
import { BillingAccountsVService, CustomerVService } from '../../services/V2/gozer';
import { handleError } from '../shared/Functions';
import { useParams } from 'react-router';
import { CustomerDetails } from './BillingAccount/CustomerDetails';
import { ExtraDetails } from './BillingAccount/ExtraDetails';
import { Ledger } from './BillingAccount/Ledger';
import { Tokens } from './BillingAccount/Tokens';
import { authProvider } from '../../services/Security';

export const BillingAccount = (props) => {
    const [billingAccount, setBillingAccount] = useState<any>();
    const [style, setStyle] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const { billingAccountId } = useParams<{ billingAccountId: string }>();

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if(!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token);
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        var message = JSON.stringify({
            hideSearch: true
        });
        window.parent.postMessage(message, '*');
        BillingAccountsVService.billingAccountsVGetById(billingAccountId)
            .then(b => setBillingAccount(b))
            .catch(err => {
                handleError(err)
            })
    }, [billingAccountId, loading])

    useEffect(() => {
            setStyle({
                marginTop: "25px",
                width: "100vw"
            })
    }, [])

    if(!billingAccount) return null;

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                <div style={{backgroundColor: "white", borderRadius: "10px"}}>
                    <div style={{padding: '15px', margin:'0px'}}>
                        <div className="row col-12">
                            <Grid item xs={12}
                                container={true}
                                alignContent="flex-start">
                                <CustomerDetails
                                    loading={loading}
                                    setLoading={setLoading}
                                    billingAccountId={billingAccountId}
                                    billingAccount={billingAccount}
                                    editCustomer={CustomerVService.customerVUpdate}
                                    editEnrollment={BillingAccountsVService.billingAccountsVUpdateEnrollment}
                                    editBillingAccount={BillingAccountsVService.billingAccountsVUpdateBillingAccount}
                                    style={style} />
                            </Grid>
                            <Grid item xs={12}
                                container={true}
                                alignContent="flex-start">
                                <ExtraDetails
                                    loading={loading}
                                    setLoading={setLoading}
                                    billingAccountId={billingAccountId}
                                    districtId={billingAccount.districtId}
                                    style={style} />
                            </Grid>
                            <Grid item xs={12}
                                container={true}
                                alignContent="flex-start">
                                <Ledger
                                    loading={loading}
                                    setLoading={setLoading}
                                    billingAccountId={billingAccountId}
                                    style={style}
                                    successCallback={props.successToast}
                                    failureCallback={props.errorToast} />
                            </Grid>
                            <Grid item xs={12}
                                container={true}
                                alignContent="flex-start">
                                <Tokens
                                    loading={loading}
                                    setLoading={setLoading}
                                    billingAccountId={billingAccountId}
                                    style={style} />
                            </Grid>
                        </div>
                    </div>
                </div>
            </Container>
        </React.Fragment>
    );
}